import { State } from '../../reducers/rootReducer'
import { ConfigurationDataState } from '../../reducers/configurationDataReducer'

const configurationDataSelector = (state: State): ConfigurationDataState => state.configurationData

export default configurationDataSelector
